import React from 'react'
import {
    Dialog,
    DialogTitle,
    DialogDescription,
    DialogContent,
    Button,
    Flex,
    IconButton
} from "@sparrowengg/twigs-react";
import { CloseIcon } from "@sparrowengg/twigs-react-icons";
import axios from 'axios';

function DeleteModal({ deleteModal, setDeleteModal, setSmsData }) {
    const serverConfig = process.env.REACT_APP_HUB_BACKEND_HOSTNAME;
    
    const deleteAllSMS = async() => {
        try {
            await axios.delete(`${serverConfig}/sms/delete-all`);
            setSmsData([]);
        } catch (error) {
            console.error('Error deleting messages:', error);
        }
    }

    return (
        <Dialog 
            open={deleteModal} 
            css={{
                'p': {
                    fontFamily: 'DM Sans'
                },
                'button': {
                    fontFamily: 'DM Sans'
                }
            }}
        >
            <DialogContent css={{
                maxWidth: '400px',
                padding: '$6',
                borderRadius: '$lg',
                boxShadow: '0 4px 6px rgba(0, 0, 0, 0.1)',
                fontFamily: 'DM Sans'
            }}>
                <Flex justifyContent="space-between" alignItems="center" css={{ marginBottom: '$4' }}>
                    <DialogTitle css={{ 
                        fontSize: '$xl',
                        fontWeight: '600',
                        color: '$black900',
                        fontFamily: 'DM Sans'
                    }}>
                        Delete All Messages
                    </DialogTitle>
                    <IconButton
                        variant="ghost"
                        onClick={() => setDeleteModal(false)}
                        css={{
                            color: '$black500',
                            '&:hover': {
                                background: '$black100',
                                color: '$black700'
                            }
                        }}
                    >
                        <CloseIcon />
                    </IconButton>
                </Flex>

                <DialogDescription css={{ 
                    color: '$black600', 
                    fontSize: '$md',
                    lineHeight: '1.5',
                    marginBottom: '$6',
                    fontFamily: 'DM Sans'
                }}>
                    Are you sure you want to delete all messages? This action cannot be undone.
                </DialogDescription>

                <Flex gap="$4" justifyContent="flex-end" css={{ fontFamily: 'DM Sans' }}>
                    <Button 
                        variant="ghost" 
                        onClick={() => setDeleteModal(false)}
                        css={{
                            color: '$black700',
                            '&:hover': {
                                background: '$black100'
                            },
                            fontFamily: 'DM Sans'
                        }}
                    >
                        Cancel
                    </Button>
                    <Button 
                        variant="solid"
                        color="error" 
                        onClick={async() => {
                            await deleteAllSMS();
                            setDeleteModal(false);
                        }}
                        css={{
                            background: '$red600',
                            '&:hover': {
                                background: '$red700'
                            },
                            fontFamily: 'DM Sans'
                        }}
                    >
                        Delete All
                    </Button>
                </Flex>
            </DialogContent>
        </Dialog>
    )
}

export default DeleteModal